module.exports = __webpack_public_path__ + "static/media/normalization2.26bb978f.png";